/*
 * ------------------------------------------------------------
 * CORRECTIF COMPATIBILITE WEBVIEW (navigateur integre Facebook / Instagram)
 * Date : 2026-08-17
 *
 * PROBLEME CORRIGE
 * La version d'origine de ce fichier (thème Horizon) contenait :
 *     return !(viewTransition instanceof ViewTransition) || isLowPowerDevice();
 * `ViewTransition` y est reference comme variable globale sans verification.
 * Dans les WebView qui declenchent bien les evenements pageswap/pagereveal
 * mais n'exposent pas ce global (cas du navigateur integre Facebook Android),
 * cette ligne leve une ReferenceError. Le gestionnaire s'interrompt,
 * skipTransition() n'est jamais appele, la transition reste bloquee et la
 * nouvelle page n'est jamais peinte => PAGE BLANCHE a chaque navigation.
 *
 * Consequence : tout le tunnel d'achat etait inaccessible depuis les
 * publicites Facebook (accueil > produit > panier > checkout).
 *
 * CORRECTION
 * Detection sure du support, aucune reference a un global inexistant,
 * try/catch systematique : une exception ne peut plus bloquer le rendu.
 * Les transitions de page sont volontairement neutralisees (navigation
 * classique) : aucun impact fonctionnel, uniquement l'animation en moins.
 *
 * A conserver tant que le thème Horizon n'a pas corrige ce point en amont.
 * En cas de mise a jour du thème, verifier que ce correctif est toujours
 * present dans ce fichier.
 * ------------------------------------------------------------
 */
(function () {
  // Retirer le bloqueur de rendu : sans lui, la page s'affiche toujours.
  try {
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker && blocker.remove) blocker.remove();
  } catch (e) {}

  function safeSkip(event) {
    try {
      var vt = event && event.viewTransition;
      if (vt && typeof vt.skipTransition === 'function') {
        vt.skipTransition();
      }
    } catch (e) {
      /* Ne jamais laisser une exception bloquer le rendu de la page. */
    }
  }

  try {
    window.addEventListener('pageswap', safeSkip);
    window.addEventListener('pagereveal', safeSkip);
  } catch (e) {}

  // Filet de securite : forcer la visibilite du document si besoin.
  function forceVisible() {
    try {
      if (document.body && getComputedStyle(document.body).visibility === 'hidden') {
        document.body.style.visibility = 'visible';
      }
    } catch (e) {}
  }
  try {
    window.addEventListener('pagereveal', function () {
      setTimeout(forceVisible, 0);
      setTimeout(forceVisible, 300);
    });
    document.addEventListener('DOMContentLoaded', forceVisible);
  } catch (e) {}
})();
